import { Component, Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Accessory } from 'src/app/models/configurators-2d/applications/closet-doors-custom/accessory';
import { ConfigurationAccessory } from 'src/app/models/configurators-2d/applications/closet-doors-custom/configuration/configuration-accessory';
import { ClosetDoorsCustomService } from 'src/app/services/configurators-2d/applications/closet-doors-custom.service';
import { ClosetDoorsCustomConfiguratorItem } from '../../../configurator/applications/closet-doors-custom-configurator-item';
import { IBaseComponent } from '../../../configurator/i-base-component';
import { Configurators2DComponent } from '../../../configurators-2d.component';
import { ClosetDoorsCustomPreviewComponent } from '../preview/preview.component';
import { AccessoryCategory } from 'src/app/models/configurators-2d/applications/closet-doors-custom/accessory-category';
import { OpeningSystemType } from 'src/app/enum/closet-doors-custom/opening-system-type.enum';

@Component({
  selector: 'ng-closet-doors-custom-accessories',
  templateUrl: './accessories.component.html',
})
@Injectable({
  providedIn: 'root',
})
export class ClosetDoorsCustomAccessoriesComponent
  extends ClosetDoorsCustomConfiguratorItem
  implements OnInit, IBaseComponent
{
  accessoryCategories: AccessoryCategory[] = [];

  /** Sous-étape pour les sections à afficher ou non */
  subStep: number = 1;

  currentLang: string;
  baseImgURL: string;
  preview: ClosetDoorsCustomPreviewComponent;

  constructor(
    private translate: TranslateService,
    closetDoorCustomService: ClosetDoorsCustomService,
    configurators2DComponent: Configurators2DComponent
  ) {
    super(closetDoorCustomService);
    this.currentLang = this.translate.getBrowserLang();
    this.baseImgURL = this.service.apiUrl;
    this.preview = configurators2DComponent.preview as ClosetDoorsCustomPreviewComponent;
  }

  ngOnInit(): void {
    this.service.getAccessories().then(accessories => {
      this.accessoryCategories = accessories;
      this.configuration.requiredAccessoryTypes = this.accessoryCategories.filter(ac => ac.isRequired);

      if (this.preview.isPreviewLoading == null) {
        this.preview.getProfilesImages();
        this.preview.update();
      }

      // supprimer les accessoires précédemment sélectionnés et plus compatibles
      for (let i = this.configuration.configurationAccessories.length - 1; i >= 0; i--) {
        const id = this.configuration.configurationAccessories[i].accessoryId;
        if (!this.accessoryCategories.find(cat => cat.accessories.find(a => a.id == id))) {
          this.configuration.configurationAccessories.splice(i, 1);
        }
      }

      //sélectionner l'accessoire par défaut si rien n'est sélectionné dans sa catégorie
      this.accessoryCategories.forEach(ac => {
        let listIds = ac.accessories.map(a => a.id);
        //si aucun accessoire n'est sélectionné dans sa catégorie
        if (!this.configuration.configurationAccessories.find(c => listIds.includes(c.accessoryId))) {
          if (ac.accessories.find(a => a.isDefault)) {
            this.configuration.configurationAccessories.push(
              new ConfigurationAccessory(ac.accessories.find(a => a.isDefault))
            );
          }
        }
      });

      this.configuration.checkAccessories = false;
    });
  }

  toggleCollapse(step: number) {
    this.subStep = step;
  }

  selectAccessory(accessory: Accessory, category: AccessoryCategory) {
    const accessoryIndex = this.configuration.configurationAccessories?.findIndex(a => a.accessoryId === accessory.id);

    if (
      accessoryIndex >= 0 &&
      (category.name !== 'Poignées' || this.configuration.openingSystem.type === OpeningSystemType.sliding)
    ) {
      // on retire l'accessoire sauf la poignée qui est obligatoire
      this.configuration.configurationAccessories.splice(accessoryIndex, 1);
      this.service.checkHasDisabledProducts();
    } else if (!accessory.isDisabled) {
      //désactiver l'ancienne sélection pour poignées, joints et compensateurs de plinthe
      if (category.name === 'Poignées' || category.name === 'Joints' || category.name === 'Compensateurs de plinthe') {
        //est-ce qu'un élément est sélectionné ?
        let listIds = category.accessories.map(a => a.id);
        let oldSelectionIndex = this.configuration.configurationAccessories?.findIndex(a =>
          listIds.includes(a.accessoryId)
        );
        if (oldSelectionIndex >= 0) {
          this.configuration.configurationAccessories.splice(oldSelectionIndex, 1);
        }
      }

      // on l'ajoute que s'il n'est pas désactivé
      this.configuration.configurationAccessories.push(new ConfigurationAccessory(accessory));
      this.service.checkHasDisabledProducts();
    }
  }

  isAccessorySelected(id: number) {
    return !!this.configuration.configurationAccessories?.find(a => a.accessoryId === id);
  }

  isNextButtonActive(): boolean {
    return (
      this.checkRequiredAccessoriesIsSelected() &&
      (this.configuration.hasQuotation || !this.configuration.hasDisabledProducts)
    );
  }

  private checkRequiredAccessoriesIsSelected(): boolean {
    if (!this.configuration.requiredAccessoryTypes) {
      return false;
    }

    if (this.configuration.requiredAccessoryTypes.length === 0) {
      return true;
    }

    const accessoryTypeIds = this.configuration.configurationAccessories.map(ca => ca.accessory.accessoryTypeId);

    return this.configuration.requiredAccessoryTypes.some(ac => ac.isRequired && accessoryTypeIds.includes(ac.id));
  }

  checkPageChangeCapability(): boolean {
    return (
      this.configuration.doorRange &&
      !this.configuration.doorRange.isDisabled &&
      this.configuration.frame &&
      !this.configuration.frame.isDisabled &&
      this.configuration.frameFinish &&
      !this.configuration.frameFinish.isDisabled &&
      this.configuration.configurationDoorStructures?.every(
        ds =>
          !ds.doorStructure.isDisabled &&
          ds.configurationDoorSections.every(
            s =>
              !s.color.isDisabled &&
              !s.doorSection.colorCategories.find(cc => cc.id === s.color.colorCategoryId).isDisabled
          )
      )
    );
  }
}
